import React from 'react';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import ImageUploadTool from '../../Shared/UI/ImageUploadTool/components/ImageUploadTool';
import { updateCurrentUserProfilePicture } from './restApi';

import { useProfileState, useProfileActions } from './ProfileContext';

import styles from './ProfilePicture.module.scss';

const ProfilePicture = () => {
  const state = useProfileState();
  const { onResponse, onError, openProfilePictureUpdateModal, closeProfilePictureUpdateModal, updateProfilePictureBase64StringAndFileName } = useProfileActions();


  if (state.loading) {
    return (
      <section id={styles.profilePictureSection}>
        <div id={styles.profilePictureLoading} />
      </section>
    );
  }

  return (
    <>
      <section id={styles.profilePictureSection}>
        <img
          id={styles.profilePicture}
          src={state.user?.profilePicturePath}
          onClick={() => {
            if (state.user?.isAuthenticatedUser) {
              openProfilePictureUpdateModal();
            }
          }}
        />
      </section>
      <StandardModal
        isOpen={state.profilePictureUpdateModalIsOpen}
        contentLabel="Update Profile Picture"
        onRequestClose={() => {
          if (state.user?.isAuthenticatedUser) {
            closeProfilePictureUpdateModal();
          }
        }}
      >
        <ImageUploadTool
          useProviderState={useProfileState}
          updateProfilePictureBase64StringAndFileName={updateProfilePictureBase64StringAndFileName}
          onSaveClick={(profilePictureBase64String) => {
            updateCurrentUserProfilePicture({
              onResponse,
              onError,
              body: {
                profilePicture: profilePictureBase64String,
                authenticityToken: document.querySelector("meta[name='csrf-token']").getAttribute("content")
              },
            });
          }}
          onCancelClick={closeProfilePictureUpdateModal}
        />
      </StandardModal>
    </>
  );
};

export default ProfilePicture;
